import { handleActions } from 'redux-actions'

import { FetchStatus } from '@tabeeb/enums'
import * as rawActions from '../actions'

const initialState = {
  fetchStatus: FetchStatus.Idle,
  errorObject: null,
}

export default handleActions(
  {
    [rawActions.validatePowerBIReportConfiguration.request]: (state, action) => {
      return { ...state, fetchStatus: FetchStatus.Loading }
    },
    [rawActions.validatePowerBIReportConfiguration.success]: (state, action) => {
      return { ...state, fetchStatus: FetchStatus.Loaded, errorObject: null }
    },
    [rawActions.validatePowerBIReportConfiguration.failed]: (state, action) => {
      const errorMessage = action.response.data.Error?.Details || null
      let errorObject = null
      if (errorMessage) {
        errorObject = JSON.parse(errorMessage)
      }
      return { ...state, fetchStatus: FetchStatus.Failed, errorObject }
    },
    [rawActions.resetValidatePowerBIReportConfigurationConnection]: (state, action) => {
      return initialState
    },
  },
  initialState
)
